export const desktopBreakpoint: number = 1199;
